<template>
  <base-shape-dialog
    :title="'room.param.shape.title' | i18n"
    :subtitle="'room.param.shape.subtitle' | i18n"
    :description="'room.param.shape.description' | i18n"
    v-model="shape" />
</template>


<script>
  import Vue from 'vue'
  import BaseShapeDialog from "./BaseShapeDialog"
  import { roomShapes, defaultRoomShape } from '../../api/constants'

  export default {
    computed: {
      shape: {
        get() {
          return this.$store.state.roomParams.shape
        },
        set(shape) {
          this.$store.commit('roomParams/SET_SHAPE', shape)
        }
      }
    },

    created() {
      if(this.shape == null) {
        this.$store.commit('roomParams/SET_SHAPE', defaultRoomShape)
      }
    },

    components: {
      BaseShapeDialog
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog/RoomShapeDialog.vue